export default __webpack_public_path__ + "static/media/bell.30cad9f0.svg";